/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface WeeklyUtilizationResult { 
    isoYear: number;
    isoWeek: number;
    availableMinutes: number;
    bookedMinutes: number;
    blockerMinutes: number;
    utilizationPct: number;
}
export const WeeklyUtilizationResult_isoYear_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const WeeklyUtilizationResult_isoWeek_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const WeeklyUtilizationResult_availableMinutes_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const WeeklyUtilizationResult_bookedMinutes_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const WeeklyUtilizationResult_blockerMinutes_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const WeeklyUtilizationResult_utilizationPct_Validators: ValidatorFn[] =
    [  Validators.required, ];


